export default __webpack_public_path__ + "static/media/pacmanr.6b801567.svg";